import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';

const currentYear = new Date().getFullYear();

interface YearSelectorProps {
  start?: number;
  end?: number;
  onChange?: (event: SelectChangeEvent) => void;
  allowAll?: boolean;
  value?: string;
}

const YearSelector = ({
  start = 2022,
  end = currentYear,
  onChange = () => null,
  allowAll = true,
  value = allowAll ? '0' : String(end),
}: YearSelectorProps) => {
  const items = React.useMemo(
    () => Array.from(Array(end - start), (_, index) => String(currentYear - index)),
    [start, end]
  );

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1 }}>
      <FormControl size="medium" sx={{ mr: 4, width: 200, mt: '-1.8rem'}}>
        <InputLabel id="typel" sx={{ pt: '1rem'}}>Ano de Emissão</InputLabel>
        <Select
          labelId="type"
          label="Ano de Emissão"
          name="type"
          variant="standard"
          sx={{
            '& .MuiInputBase-input': {
              paddingBottom: '-12px',
            },
          }}
          inputProps={{
            name: 'type',
          }}
          defaultValue={allowAll ? '0' : items[0]}
          value={value}
          onChange={onChange}
        >
          {allowAll && <MenuItem value="0">Todos os Anos</MenuItem>}
          {items.map((item) => (
            <MenuItem key={`year_picker${item}`} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default YearSelector;
